module.exports = __webpack_public_path__ + "img/nav_icon_pediatrics.310bea8e.svg";